import React, { useContext } from 'react';
import { LoanCalculatorFormGroup } from '../LoanCalculatorFormGroup';
import { LoanCalculatorContext } from '../../context';

import styled from '@emotion/styled';
import { media } from '../../../../services/media';

export const LoanCalculatorForm = () => {
    const { fields, handleFieldChange } = useContext(LoanCalculatorContext);

    return (
        <LoanCalculator>
            {fields.map((field: any) => {
                return (
                    <LoanCalculatorFormGroup
                        key={field.id}
                        handleFieldChange={handleFieldChange}
                        {...field}
                    />
                );
            })}
        </LoanCalculator>
    );
};

const LoanCalculator = styled.div`
    margin: 30px 0 0 0;

    .FormGroup {
        display: flex;
        height: 48px;
        color: #fff;

        font-weight: 400;
        margin: 0 0 30px;

        font-size: 18px;

        ${media.min('lg')} {
            font-size: 20px;
        }
    }

    .FormGroup__control {
        cursor: pointer;
        user-select: none;
        align-items: center;
        line-height: 1;
        display: flex;
        background-image: linear-gradient(to top, #15d8e2 0%, #54ef93 100%);

        &:hover {
            background-image: linear-gradient(to top, #15d8e2 0%, #50dc89 100%);
        }

        &--left {
            border-radius: 30px 0 0 30px;
            padding: 0 25px 0 30px;
        }

        &--right {
            border-radius: 0 30px 30px 0;
            padding: 0 30px 0 25px;
        }
    }

    .FormGroup__number {
        /* Chrome, Safari, Edge, Opera */
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        &[type='number'] {
            -moz-appearance: textfield;
        }

        border: none;

        background-color: #fff;
        color: black;
        border: 1px solid #d4d4d4;
        border-width: 1px 0 1px 0;
        font-size: 16px;
        font-family: inherit;
        line-height: 1;
        width: 100%;

        text-align: center;

        ${media.min('lg')} {
            font-size: 20px;
        }
    }

    .FormGroup__text,
    .FormGroup__label {
        margin: 0 0 10px;
        display: block;
    }
`;
